import { useState } from "react";
import styles from "./styles.module.scss";
import { Button } from "@common/button";
import { errorToast, successToast } from "@utils/toaster";
import { useNavigate } from "react-router";
import { useStripe } from "@stripe/react-stripe-js";
import { axiosInstance } from "@api/index";
import { updateDataLayer } from "@utils/updateDataLayer";
import { CustomCheckoutModal } from "src/routes/containers/paywalls/shared/components/plan/components/customCheckoutModal";

export const PaymentOptions = ({ activePlan, idempotencyKey, onSkip, isWalky }) => {
  const stripe = useStripe();
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handlePurchaseSuccess = (subscriptionId) => {
    const userId = localStorage.getItem("userId");
    updateDataLayer({
      event: "Upsale",
      paymentMethod: "CREDIT_CARD",
      product_name: activePlan.title,
      currency: activePlan.currency,
      amount: +activePlan.priceAmount / 100,
      userId,
      subscriptionId,
    });
    successToast({ message: "Payment successful! Thank you!" });
    navigate("/activate");
  };

  const handleQuickPurchase = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post(
        "/me/subscriptions/quick-purchase",
        {
          subscriptionPlanId: activePlan.id,
          idempotencyKey,
        }
      );
      const {
        available,
        requiresConfirmation,
        confirmationStripeClientSecret,
        subscriptionId,
      } = response.data;

      if (!available) {
        setModalOpen(true);
        return;
      }
      if (requiresConfirmation) {
        await handle3DSecureConfirmation(
          confirmationStripeClientSecret,
          subscriptionId
        );
      } else {
        handlePurchaseSuccess(subscriptionId);
      }
    } catch (e) {
      if (
        e.response?.status === 402 ||
        e.response?.data?.code === "QUICK_PAYMENT_NOT_AVAILABLE"
      ) {
        setModalOpen(true);
        errorToast({ message: e.response.data.message });
      }
      errorToast({ message: e.response.data.message });
    } finally {
      setLoading(false);
    }
  };

  const handle3DSecureConfirmation = async (clientSecret, subscriptionId) => {
    const { error, paymentIntent } = await stripe.confirmCardPayment(
      clientSecret
    );
    if (error) {
      errorToast({ message: error.message });
    } else if (paymentIntent.status === "succeeded") {
      handlePurchaseSuccess(subscriptionId);
    } else {
      errorToast({ message: "Payment could not be confirmed" });
    }
  };

  const closeModal = () => {
    setModalOpen(false);
  };
  return (
    <>
      <Button
        onClick={handleQuickPurchase}
        disabled={loading}
        className={isWalky ? styles.getPlanButtonWalky: styles.getPlanButton}
      >
        {loading ? <div className={styles.spinner}></div> : "CONTINUE"}
      </Button>

      <button className={styles.skipButton} onClick={onSkip}>
        SKIP
      </button>
      {isModalOpen && (
        <CustomCheckoutModal onClose={closeModal} activePlan={activePlan} isWalky={isWalky}/>
      )}
    </>
  );
};
